import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'BaseScore' })({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8
    },
    root: {
        display: 'flex',
        flexDirection: 'column',
        borderRadius: 12,
        border: '1px solid #ECECEC'
    },
    collapseRoot: {
        boxShadow: '0px 8px 16px 0px rgba(176, 178, 186, 0.10), 0px 12px 32px 0px rgba(176, 178, 186, 0.25)',
        borderRadius: 12,
        background: '#FFF'
    },
    collapseWrapperInner: {
        display: 'flex',
        padding: '8px 8px 16px 8px',
        flexDirection: 'column',
        gap: 16,
        boxSizing: 'border-box'
    }
});
